import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { QualificationRequirement } from './types/QualificationRequirement';

export default (makeCall: MakeCall) => (requirementId: number | string) =>
  makeCall<QualificationRequirement>(
    'GET',
    `/api/v2/qualification/requirements/${requirementId}`,
  );
